import React from 'react';
import styled from '@emotion/styled';
import { PageTitle } from 'ui/components/elements/PageTitle/PageTitle';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { useCompanyEdit } from './useCompanyEdit';
import { AboutService } from 'ui/components/company/features/AboutService';
import { mqUser } from 'utils/responsive';
import { CompanyEditForm } from 'ui/components/agent/patterns/CompanyEditForm/CompanyEditForm';
import { CompanySearchResult } from 'domain/entities/CompanySearchResult/CompanySearchResult';

const BgWrapper = styled.div`
    padding: 18px 50px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: left;
    background-color: #f8f9fd;
    height: auto;
    min-height: calc(100vh - var(--height-pc-header));

    ${mqUser('SP')} {
        padding: 18px 15px;
    }
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 40px;
`;

export const CompanyEdit: React.FC = () => {
    const {
        user,
        control,
        loading,
        errors,
        areaChoices,
        employeeChoices,
        industryChoices,
        revenueChoices,
        agentTypeChoices,
        showSnackbar,
        notRegistrationComplete,
        editing,
        setEditing,
        setShowSnackbar,
        submit,
        setValue,
        watch,
    } = useCompanyEdit();

    const onCompanySelect = (buyer: CompanySearchResult) => {
        setValue('name', buyer.name);
        setValue('company_code', buyer.number);
    };

    const descriptions: { [key: string]: string[] } = {
        説明: [
            notRegistrationComplete
                ? '企業プロフィールを完成させて売り手企業へのオファー率をアップさせましょう'
                : 'オファーが成立しない場合は、企業情報を修正して魅力的な文章を書きましょう',
        ],
    };

    return (
        <BgWrapper>
            <Wrapper>
                <SnackBar message="企業プロフィールを更新しました。" open={showSnackbar} setOpen={setShowSnackbar} />
                <div>
                    <PageTitle title="企業プロフィール" />
                    <AboutService descriptions={descriptions} />
                </div>
                <CompanyEditForm
                    user={user}
                    control={control}
                    loading={loading}
                    errors={errors}
                    areaChoices={areaChoices}
                    employeeChoices={employeeChoices}
                    industryChoices={industryChoices}
                    revenueChoices={revenueChoices}
                    agentTypeChoices={agentTypeChoices}
                    onCompanySelect={onCompanySelect}
                    watch={watch}
                    setValue={setValue}
                    submit={submit}
                    setEditing={setEditing}
                    editing={editing}
                />
            </Wrapper>
        </BgWrapper>
    );
};
